module.exports = __webpack_public_path__ + "static/media/logo-ana.6ef8294c.webp";